<app-dialog-heading [heading]="data.heading"></app-dialog-heading>

<div style="align-content: center">
  <img style="max-height: 70vh" src="{{data.src}}" alt="Claim flow diagram" />
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button (click)="onOkayClick()" color="primary">Okay</button>
</mat-dialog-actions>
